import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 220px;\n  margin: 30px auto;\n  &&& {\n    background-color: ", ";\n  }\n  @media screen and (max-width: ", "px) {\n    max-width: 335px;\n    width: 100%;\n    margin: 0px auto 30px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n\n  /* Fix layering/overflow issue in safari */\n  transform: translate3d(0, 0, 0);\n\n  .slick-list {\n    height: 100%;\n  }\n\n  .slick-arrow {\n    width: 44px;\n    height: 44px;\n    border-radius: 100%;\n    background: white;\n    box-shadow: ", ";\n    margin: 0 50px;\n    z-index: 8;\n  }\n\n  .slick-arrow:after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-size: fill;\n  }\n\n  .slick-next:after {\n    background: url(\"", "\") no-repeat center center;\n    transform: scaleX(-1);\n  }\n\n  .slick-prev:after {\n    background: url(\"", "\") no-repeat center center;\n  }\n\n  .slick-dots {\n    bottom: 15px;\n    li {\n      margin: 0;\n      button {\n        &:before {\n          background-color: ", ";\n          border-radius: 50%;\n          content: '';\n          height: 8px;\n          width: 8px;\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { useRef } from 'react';
import Slider, { Settings } from 'react-slick';
import { isMobile } from 'is-mobile';
import LeftArrowIcon from '../assets/icons/left-arrow.svg';
import styled from '../utils/styling/styled-components';
import { Card } from '../Card';
import { Button } from '../Button';
import { PageDivider } from '../Page';
import { CAROUSEL_NEXT_BUTTON, CAROUSEL_ARROW_BUTTON } from '../utils/testing/TestIDs';
var StyledCard = styled(Card)(_templateObject(), function (props) {
  return props.theme.shadows.lgMedium;
}, LeftArrowIcon, LeftArrowIcon, function (props) {
  return props.theme.colors.stoneLight;
});
var NextButton = styled(Button)(_templateObject2(), function (props) {
  return props.isLastSlide ? props.theme.colors.green : props.theme.colors.slate;
}, function (props) {
  return props.theme.breakpoints.sm;
}); //Allows us to pass data test ids to the arrow buttons

var CustomArrow = styled.button(_templateObject3());

var CustomArrowComponent = function CustomArrowComponent(_ref) {
  var className = _ref.className,
      style = _ref.style,
      onClick = _ref.onClick,
      testId = _ref.testId;
  return /*#__PURE__*/React.createElement(CustomArrow, {
    className: className,
    style: _objectSpread({}, style),
    onClick: onClick,
    "data-testid": testId
  });
};

var sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: isMobile(),
  prevArrow: /*#__PURE__*/React.createElement(CustomArrowComponent, {
    testId: CAROUSEL_ARROW_BUTTON + 'left'
  }),
  nextArrow: /*#__PURE__*/React.createElement(CustomArrowComponent, {
    testId: CAROUSEL_ARROW_BUTTON + 'right'
  })
};

var Carousel = function Carousel(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      customSlickSettings = _ref2.customSlickSettings,
      testId = _ref2.testId,
      hasNextButton = _ref2.hasNextButton,
      nextButtonTextLastSlide = _ref2.nextButtonTextLastSlide,
      isLastSlide = _ref2.isLastSlide,
      dividerPadding = _ref2.dividerPadding,
      handleNextButtonLastSlide = _ref2.handleNextButtonLastSlide,
      sliderRef = _ref2.sliderRef;

  var settings = _objectSpread(_objectSpread({}, sliderSettings), customSlickSettings);

  sliderRef = sliderRef || useRef();

  var handleNextPress = function handleNextPress() {
    if (isLastSlide) {
      handleNextButtonLastSlide();
    } else {
      var _sliderRef, _sliderRef$current;

      (_sliderRef = sliderRef) === null || _sliderRef === void 0 ? void 0 : (_sliderRef$current = _sliderRef.current) === null || _sliderRef$current === void 0 ? void 0 : _sliderRef$current.slickNext();
    }
  };

  return /*#__PURE__*/React.createElement(StyledCard, {
    className: className,
    "data-testid": testId || 'carousel_container'
  }, /*#__PURE__*/React.createElement(Slider, _extends({}, settings, {
    ref: function ref(slider) {
      return sliderRef.current = slider;
    }
  }), children), hasNextButton && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageDivider, {
    thin: true,
    className: "page-divider",
    containerPadding: dividerPadding !== null && dividerPadding !== void 0 ? dividerPadding : 0
  }), /*#__PURE__*/React.createElement(NextButton, {
    isLastSlide: isLastSlide,
    className: "next-button",
    onPress: handleNextPress,
    "data-testid": CAROUSEL_NEXT_BUTTON
  }, isLastSlide ? nextButtonTextLastSlide : 'Next')));
};

export { Carousel };